import { render, staticRenderFns } from "./EventoImagen.vue?vue&type=template&id=275d23a6&scoped=true"
import script from "./EventoImagen.vue?vue&type=script&lang=js"
export * from "./EventoImagen.vue?vue&type=script&lang=js"
import style0 from "./EventoImagen.vue?vue&type=style&index=0&id=275d23a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275d23a6",
  null
  
)

export default component.exports